import React from 'react'

export default function MFCardBody({children, ...props}) {
  return (
    <div className="card-body" {...props}>
        {children}
    </div>
  )
}
